import TagManager from 'react-gtm-module';

export type FacetPlacement = 'pinned' | 'hidden';

export interface TrackPlpFacetAppliedProps {
  data: {
    interactionLocation: string;
    facetType: string;
    facetName: string;
    facetPlacement: FacetPlacement;
    activeFacetCount: number;
    activeFacetTypeCount: number;
    activeFacetTypes: string;
  };
}

export const trackPlpFacetApplied = ({ data }: TrackPlpFacetAppliedProps) => {
  const {
    interactionLocation,
    facetType,
    facetName,
    facetPlacement,
    activeFacetCount,
    activeFacetTypeCount,
    activeFacetTypes,
  } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'plp_facet_applied',
      interaction: {
        interaction_location: interactionLocation,
        facet_type: facetType,
        facet_name: facetName,
        facet_placement: facetPlacement,
        active_facet_count: activeFacetCount,
        active_facet_type_count: activeFacetTypeCount,
        active_facet_types: activeFacetTypes,
      },
    },
  });
};
